import React from "react";
import Page from "./Page";

const companiesColumns = [
  {
    accessor: "selection",
    massSelection: true,
    width: 20,
    Header: "",
  },
  {
    Header: "Name",
    accessor: "name",
    width: 200,
    autocomplete: true,
  },
  {
    Header: "Industry",
    accessor: "industry",
    width: 150,
    autocomplete: true,
  },
  {
    Header: "Website",
    accessor: "website",
    width: 150,
    autocomplete: true,
  },
  {
    Header: "Email",
    accessor: "email",
    width: 150,
    autocomplete: true,
  },
  {
    Header: "Phone",
    accessor: "phone",
    width: 150,
    autocomplete: true,
  },
  {
    Header: "Address",
    accessor: "address",
    width: 300,

    address: true,
  },
  {
    Header: "Created At",
    accessor: "created_at",
    width: 150,
    datePicker: true,
  },
  {
    Header: "Updated At",
    accessor: "updated_at",
    width: 150,
    datePicker: true,
  },
  {
    Header: "Created By",
    accessor: "created_by",
    chipDropdown: true,
    width: 150,
    chipDropdownValueField: "id",
    chipDropdownDisplay: (user) => `${user.first_name} ${user.last_name}`.trim(),
    chipDropdownChipColor: (row) =>
      row.active === "n" ? "#F08080" : row.chip_color || "#e0e0e0",
  },
];

const Companies = (props) => {
  return (
    <Page
      tableName="companies"
      title="Company"
      columns={companiesColumns}
      fromPage="Company"
      {...props}
    />
  );
};

export default Companies;
